const LOCAL_DEBUG_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  '::1',
]);

const TEST_HOST_PATTERNS = [
  'lifelog-test-aa7d6',
  'test.lifelog.care',
];

const getBrowserWindow = () => (typeof window === 'undefined' ? null : window);

export const isDebugToolsAllowed = (windowRef = getBrowserWindow()) => {
  if (!windowRef) {
    return false;
  }

  try {
    const hostname = String(windowRef.location?.hostname || '').toLowerCase();
    return LOCAL_DEBUG_HOSTS.has(hostname)
      || hostname.endsWith('.localhost')
      || TEST_HOST_PATTERNS.some((pattern) => hostname.includes(pattern));
  } catch (_error) {
    return false;
  }
};

export const isDebugFlagEnabled = (flagNames = [], {
  windowRef = getBrowserWindow(),
  allowWithoutFlag = false,
} = {}) => {
  if (!isDebugToolsAllowed(windowRef)) {
    return false;
  }

  try {
    const hostname = String(windowRef.location?.hostname || '').toLowerCase();
    if (LOCAL_DEBUG_HOSTS.has(hostname) || hostname.endsWith('.localhost')) {
      return true;
    }
  } catch (_error) {
    return false;
  }

  if (allowWithoutFlag) {
    return true;
  }

  const normalizedFlags = (Array.isArray(flagNames) ? flagNames : [flagNames])
    .map((flagName) => String(flagName || '').trim())
    .filter(Boolean);

  if (!normalizedFlags.length) {
    return false;
  }

  try {
    const searchParams = new URLSearchParams(windowRef.location?.search || '');
    return normalizedFlags.some((flagName) => (
      searchParams.get(flagName) === '1'
      || windowRef.localStorage?.getItem(flagName) === '1'
    ));
  } catch (_error) {
    return false;
  }
};
